// Class manipulation

window.UISelect = {
  // Base
  baseUrl: () => document.querySelector('[data-base-url]').getAttribute('data-base-url'),
}

window.addClassTo = (el, className) =>
  el ? el.classList.add(className) : false;

window.toggleClassTo = (el, className) =>
  el ? el.classList.toggle(className) : false;

window.removeClassFrom = (el, className) =>
  el ? el.classList.remove(className) : false;

window.removeClassFromElements = (elements, className) =>
  elements ? Array.from(elements).forEach(el => removeClassFrom(el, className)) : false;

window.removeAddClassFromElement = (element, classToRemove = '', classToAdd = '', addStyle = null) => {
  if (!element) return;
  if (classToRemove != '') removeClassFrom(element, classToRemove);
  if (classToAdd != '') addClassTo(element, classToAdd);
  if (addStyle != null) element.style = addStyle;
}

window.removeAddClassFromElements = function (elements, classToRemove = '', classToAdd = '', addStyle = null) {
  return Array.from(elements).forEach((element) =>
    removeAddClassFromElement(element, classToRemove, classToAdd, addStyle)
  );
}

window.removeElementFromDom = (elementSearch) => {
  let element = document.querySelector(elementSearch);
  return element ? element.remove() : false;
};

window.createHtmlElement = (elToCreate, ...attributes) => {
  let el = document.createElement(elToCreate);
  attributes.forEach(([key, value]) => el.setAttribute(key, value));
  return el;
}

// Selects the element and activate the scroll behavior with scrollIntoView
window.scrollTo = function (element, options = false) {
  if (!document.body.scrollIntoView) return window.location.href = element;

  var selectedElement = document.querySelector(element);
  if (!selectedElement) return;

  return selectedElement.scrollIntoView(options ? options : false);
}

// Urls
window.getUrl = function getUrl() {
  return window.location.href;
}

window.splitUrl = function splitUrl(separator = '/') {
  return window.location.href.split(separator);
}

window.haveString = function haveString(str, charSearch) {
  return str.search(charSearch);
}

window.checkIfParamExistsInString = function checkIfParamExists(string, param) {
  if (string.indexOf(param) != -1) true;

  return false;
}

window.checkIfParamExistsInUrl = function checkIfParamExists(param) {
  if (splitUrl().indexOf(param) != -1) true;

  return false;
}

window.changeUrl = function changeUrl(url) {
  return window.history.pushState('', '', url);
}

window.getUrlVars = function getUrlVars() {
  let vars = [];
  let parts =
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars.push(key + '=' + value);
      });

  return vars;
}

window.urlSearchIsEmpty = function urlSearchIsEmpty() {
  return window.location.search == '' ? true : false;
}


window.hashGoToElementAnchor = function hashGoToElementAnchor(scrollBy = -100, hash = window.location.hash, e) {
  
  let documentHasHash = hash;
  if (!documentHasHash) return;
  
  let $elementSection = document.querySelector(documentHasHash);
  
  if ($elementSection) {
    e.preventDefault();
  }

  let browserSupportScrollIntoView = typeof document.body.scrollIntoView === 'function';

  if (!browserSupportScrollIntoView) return;

  $elementSection.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "center"
  });
}

window.clickOnHrefItens = function clickOnHrefItens(scrollBy = -100) {
  let $links = document.querySelectorAll('a');
  if (!$links) return;

  Array.from($links).forEach(linkItem => {
    let linkHref = linkItem.href;

    let linkContainsHash = linkHref.indexOf('#') !== -1;
    if (!linkContainsHash) return;

    let splitHash = linkHref.split('#')[1];

    linkItem.addEventListener('click', (e) => {
      let newHash = '#' + splitHash;

      if (history.pushState) history.pushState(null, null, newHash);

      hashGoToElementAnchor(scrollBy, newHash, e);
    });

  });
}